import Vue from "vue";
import VueRouter from "vue-router";

import obituaryRouter from "./obituary/router";
import shopRouter from "./shop/router";

import store from "@/store";

Vue.use(VueRouter);

const routes = [...obituaryRouter, ...shopRouter];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== "NavigationDuplicated") throw err;
  });
};

let isRedirectedFromHash = false; // 해시

router.beforeEach((to, from, next) => {
  const hash = window.location.hash;
  if (hash && !isRedirectedFromHash) {
    const hashPath = hash.replace("#", "");
    isRedirectedFromHash = true; // 리다이렉트 플래그 설정
    next(hashPath);
  } else {
    isRedirectedFromHash = false; // 플래그 리셋
    next();
  }
  next();
});
export default router;
